/** Whether an error stack contains one of the application's own JavaScript files. */
export function isDojoOriginStack(stack = ""): boolean {
  return /https:\/\/([\w-]+\.)*classdojo\.(com|test)(:\d+)?\/(.*\/)?[^\/]+\.js/.test(stack);
}
